module.exports = {
    language: {
        name: '中文'
    },
    user: {
        login:'Login/Register',
        logintext: 'Login'
    },
    navMenu: {
        home: 'Home',
        conference: 'Fair Facts',
        exhibition: 'Exhibitors',
        active: 'Fringe Programme',
        business: 'Business\nOpportunity',
        news: 'News',
        mine: 'My Profile',
    },
    home: {
        top: 'Top',                                     //回到顶部
        more: 'More',                                   //更多
    },
    exhibitor: {
        demandTip:'Requirement description',//需求描述
        chooseLabel:'To select items',
        filter: 'Filter',  //筛选
        search: 'Search',  //搜索展商
        productGroups: 'Product Groups',//产品类别
        countryRegion: 'Country/Region',//国家／地区
        reset: 'Reset',//重置
        searchresult: 'Search',//查看结果
        session: 'Session',//届次
        placeholder: 'Please Enter Company Name or Booth No',//请输入公司名称或展位号
        searchProduct: 'Search',//搜索产品
        placeholderProduct: 'Please enter the product name',//请输入产品名称
        all: 'All',//全部
        release:'Publish Requests',//发布需求
        Inbox:'Message Box',//收件箱
        description:'Message',//需求阐述
        answer:'Answer',//应答
        people:'people',//人
        statusOne:'Buyer',//采购类
        statusTwo:'Exhibitor',//供应类
        personal:'Personal Information',//个人资料
        collect:'My Favourite',//我的收藏
        demand:'My Request',//我的需求
        product:'Product',//产品
        enterprise:'Enterprise',//企业
        sendDemand:'My Request',//发出需求
        myAnswer:'My Reply',//我的应答
        enterpriseMessage:'Message Box',//企业留言
        feedback:'Opinion',//意见反馈
        hotline:'Technical support hotline',//技术热线
        exhibitorVerification:'Verified Exhibitor',//展商验证
        demandMessage:'Message',//需求留言
        favourite:'Favourite',//收藏
        cancel:'Cancel',//取消收藏
        companyProfile:'Company Information',//公司简介
        tapLookCall:'Click to view contact information',//点击查看联系方式
        productBrief:'Product Description',//产品简介
        brandName:'Brand Name',//品牌名称
        protection:'Protection',//环保证书
        endUse:'EndUse',//最终用途
        companyType:'Company Type',//展商类型
        certification:'Certification',//产品认证
        priceRange:'PriceRange',//价格范围
        proxy:'Proxy',//寻求代理
        dexport:'Dexport',//出口国家和地区
        market:'Market',//内销市场希望开拓的地区
        contact:'Contact',//联系方式
        productInformation:'Product Description',//产品信息
        businessDetails:'Details',//展商详情
        productDetails:'Product Description',//产品详情
        otherProducts:'Other Products',//其他产品
        activeDetails:'Details',//活动详情
        live:'Join live room',//进入直播间
    },
    business: {
        sex:'Prefix',
        man:'Mr',
        woman:'Mrs',
        Mis:'Miss',
        country:'Country／Region',
        city:'City',
        mineText:'Please fill in your personal information to continue the Online Business Matching progress.',
        demandDetails:'Details of Request',//需求详情
        businessMode:'Business Mode',//贸易属性
        multi:'(Multi-select)',//（可多选）
        trade:'Trade (within China)',//中国国内贸易
        internationalTrade:'International Trade',//国际贸易
        demandTag:'Order Tag',//需求标签
        demandPhoto:'Product Photos',//需求图片
        demandMessage:'Message',//需求描述
        repayList:"Exhibitor's Reply",//应答列表
        respond:'Respond',//应答
        waiting:'Waiting for Response',//等待回应中
        receivedResponse:'You will be contacted by phone!',//对方将通过电话联系您！
        deleteRequest:'Delete Request',//删除需求
        retrieveRequest:'Retrieve Request',//暂停发布
        personalInformation:'Please Fill in Your Personal Information',//请完善您的个人资料
        nickname:'Name',//姓名
        mobile:'Mobile',//手机
        email:'Email',//电子邮件
        companyName:'Company Name',//公司名称
        businessNature:'Business Nature',//行业属性
        deportment:'Deportment',//部门属性
        jobLevel:'Job Level',//职务级别
        save:'Save',//保存
        choose:'Choose',//请选择
        inputContents:'Please input contents',//请输入内容
        fillRequest:'Please Fill in Your Request',//填写您的需求信息
        buyer:'Buyer',//我寻找产品或资源
        exhibitor:'Exhibitor',//我提供产品或资源
        chinese:'Chinese',//中文
        publish:'Publish',//发布
        role:'Role',//需求属性
        edit: 'Edit',//编辑
        opinionType: 'Please Type Here',//请在这里输入意见反馈
        demandType:'Please input your requirements here',//请在此输入您的需求内容
        submit: 'Submit',//提交
        answerMessage: 'Answer Message',//应答留言
        call: 'Call',//致电
        inboxs:'Enterprise inbox',//企业收件箱
        replyMessage:'Message',//留言
        liaison:'Contact',//联络
    },
    login:{
        login: 'Login',//登录
        register: 'Register',//注册
        messageLogin: 'Mobile Number Login',//短信登录
        newRegister: 'Registration',//新用户注册
        username: 'Email Address/Mobile',//邮箱地址/手机号
        userEmail:'Email Address',
        password: 'Password',//密码
        read: 'I have read and agreed to',//阅读协议并同意
        userPolicy:'Terms of Use and',
        policy: ' Privacy Policy',//用户协议与隐私政策
        usernameLogin: 'Account password login',//账号密码登录
        getCode: 'Send verification Code',//获取验证码
        verifiyCode: 'Verification Code',//验证码
        already: 'Already Have Account',//已有账户登录
        confirmWords: 'Drag slide verification',//拖动滑块验证
        verificationSuccess:'Send verification email',//验证通过
        verifyEmail:'Set password',//设置密码，
        repaceCode:'Account already exists, please login directly',//已经有账号，请直接登陆
        sure:'sure',
        cancel:'cancel',
        forget:'Forget password'
        
    }
}